"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var closestByClass = function closestByClass(el, classToFind) {
  var element = el;
  // Traverse the DOM up with a while loop
  while (element && !element.classList.contains(classToFind)) {
    // Increment the loop to the parent node
    element = element.parentNode && element.parentNode.classList ? element.parentNode : null;
  }
  // At this point, the while loop has stopped and `foundElement` represents the element that has
  // the class you specified in the second parameter of the function `classToFind`

  // Then return the matched element
  return element;
};

exports.default = closestByClass;